import { render, staticRenderFns } from "./showJuriesEdition.vue?vue&type=template&id=dcd952dc"
import script from "./showJuriesEdition.vue?vue&type=script&lang=js"
export * from "./showJuriesEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports